module.exports = __webpack_public_path__ + "app/assets/images/panic-icon-small-hover.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/panic-icon-small-hover.png
// module id = 877
// module chunks = 7